"use strict";

/**
 * @function
 * @description Initializes the accessibility functionality
 * @param {element} container element of the form with checkboxes
 */
const initializeCheckboxAccessibility = element => {
    const checkboxes = document.querySelectorAll(element + " .c-input--checkbox");

    Array.from(checkboxes).forEach(item => {
        item.addEventListener("change", e => {
            let $this = $(e.currentTarget);

            if ($this.prop("checked") === true) {
                $this.attr("aria-checked", true);
            } else {
                $this.attr("aria-checked", false);
            }
        });
    });
};

module.exports = initializeCheckboxAccessibility;
